import React from 'react';

import Icon from 'Components/Globals/Elements/Icon/loadable';
import { STATUS_TRANSLATOR } from 'Constants';
import useContent from 'Hooks/useContent';
import {
	convertRialToToman,
	composeClassNames,
	convertGregorianToJalali,
} from 'Helpers';

import styles from './styles.module.scss';
import strings from './strings';

const ItemModal = ({
	amount,
	traceId,
	status,
	confirmedAt,
	payedAt,
	settlementId,
	isSettlement,
	amountSettled,
	duDate,
	vendorIncome,
}) => {
	const { formatMessage } = useContent();

	const INFORMATION = [
		{
			id: 1,
			title: formatMessage(strings.status),
			value: status,
		},
		{
			id: 2,
			title: formatMessage(strings.confirmedAt),
			value: confirmedAt ? convertGregorianToJalali(confirmedAt) : '-',
		},
		{
			id: 3,
			title: formatMessage(strings.traceId),
			value: traceId ? traceId : '-',
		},
		{
			id: 6,
			title: formatMessage(strings.amount),
			value: amount
				? amount && convertRialToToman(amount).replaceAll(',', '،')
				: '-',
			icon: 'toman',
		},
		{
			id: 4,
			title: formatMessage(strings.payedAt),
			value: payedAt ? convertGregorianToJalali(payedAt) : '-',
		},
		{
			id: 7,
			title: formatMessage(strings.amountSettled),
			value: amountSettled
				? amountSettled && convertRialToToman(vendorIncome).replaceAll(',', '،')
				: '-',
			icon: 'toman',
		},
		{
			id: 8,
			title: formatMessage(strings.duDate),
			value: duDate ? convertGregorianToJalali(duDate) : '-',
		},
		{
			id: 9,
			title: formatMessage(strings.vendorIncome),
			value: vendorIncome
				? vendorIncome && convertRialToToman(vendorIncome).replaceAll(',', '،')
				: '-',
			icon: 'toman',
		},
		{
			id: 5,
			title: formatMessage(strings.settlementId),
			value: settlementId ? settlementId : '-',
		},
	];
	const titleStyle = (id) => {
		return composeClassNames([
			'sm',
			id === 6 ? 'txt-black bold' : 'txt-text-dark',
		]);
	};
	const valueStyle = (id, value) => {
		if (value === 'pend') {
			return composeClassNames(['sm', styles.status_pending]);
		} else if (value === 'done') {
			return composeClassNames(['sm', styles.status_success]);
		} else {
			return composeClassNames([
				'sm',
				styles.value,
				id === 6 ? 'txt-black bold' : 'txt-text-dark',
			]);
		}
	};
	return (
		<>
			<div>
				{INFORMATION.filter((information) => {
					if (isSettlement) {
						return ![8, 9].includes(information.id);
					} else {
						return ![4, 5, 7].includes(information.id);
					}
				}).map((information) => (
					<div
						className={styles.wrapper}
						key={information.id}
					>
						<p className={titleStyle(information.id)}>{information.title}</p>
						<p className={valueStyle(information.id, information.value)}>
							{information.id === 1
								? STATUS_TRANSLATOR[information?.value]
								: information?.value}
							{information.icon && <Icon name={information.icon} />}
						</p>
					</div>
				))}
			</div>
		</>
	);
};

export default ItemModal;
